export class Instance {

   static parse(source: any = {}): Instance {
      const id: number = Number.parseInt(source['id']);
      const externalId: string = source['externalId'] ?? "";
     
      if (isNaN(id)) {
         throw new Error("Missing expected property 'id', or is invalid integer.");
      }
      if (!externalId) {
         throw new Error("Missing expected property 'externalId'.");
      }
      return new Instance(
         id,
         source['name'] ?? "",
         externalId,
         Number.parseInt(source['activeLicenceCount']) ?? 0,
         source['lastLicenceSyncDate'] ?? "",
         source['lastReportSubmitDate'] ?? ""
      );
   }

   constructor(
      readonly id: number,
      readonly name: string,
      readonly externalId: string,
      readonly activeLicenceCount: number,
      readonly lastLicenceSyncDate: string,
      readonly lastReportSubmitDate: string
   ) { }
}